// extracted by mini-css-extract-plugin
export default {"newBoard":"NewBoard_newBoard__JzX0w","icon":"NewBoard_icon__5kTBM","title":"NewBoard_title__PLjxU"};